module.exports = __webpack_public_path__ + "img/img_left_nav_bet_hover.f421c63b.svg";